"use strict";
exports.__esModule = true;
exports.NAMESPACES = exports.BUTTON_LABELS = exports.CAMERA_STATUS = exports.RECORDER_OPTIONS = exports.OPTIONS = void 0;
exports.OPTIONS = {
    filename: String(new Date().getTime()),
    recordingLength: 3,
    fileType: 'mp4',
    width: 1920,
    height: 1080,
    aspectRatio: 1.777777778
};
exports.RECORDER_OPTIONS = {
    type: 'video',
    mimeType: 'video/mp4',
    disableLogs: true,
    width: 1280,
    height: 720,
    aspectRatio: 1.77,
    isNewSize: false
};
exports.CAMERA_STATUS = {
    INIT: 'INIT',
    CLOSED: 'CLOSED',
    OPEN: 'OPEN',
    RECORDING: 'RECORDING',
    PREVIEW: 'PREVIEW',
    ERROR: 'ERROR'
};
exports.BUTTON_LABELS = {
    OPEN: 'Open camera',
    CLOSE: 'Close camera',
    START: 'Start recording',
    STOP: 'Stop recording',
    RETAKE: 'Retake recording',
    DOWNLOAD: 'Download recording'
};
exports.NAMESPACES = {
    CSS: 'react-record-webcam'
};
